import { useAuth } from '@/auth/hyper-auth'

const overrideConfig = {
    baseURL: process.env.VUE_APP_API_URL,
    namespace: process.env.VUE_APP_NAMESPACE,
    serviceGroup: process.env.VUE_APP_SERVICE
}

const service = {
    months (serviceIdx) {
        const { auth } = useAuth({ ...overrideConfig, serviceIdx })
        return auth.axiosIns.get('/v1/billing/months/account-group')
    },
    /** Tag */
    getTagsAll (serviceIdx) {
        const { auth } = useAuth({ ...overrideConfig, serviceIdx })
        return auth.axiosIns.get(`/v1/tags/qtype/all`)
    },
    getTagsByGroup ({ groupIdx }, serviceIdx) {
        const { auth } = useAuth({ ...overrideConfig, serviceIdx })
        return auth.axiosIns.get(`/v1/tags/qtype/group/${groupIdx}`)
    },
    getTagsByProject ({ projectIdx }, serviceIdx) {
        const { auth } = useAuth({ ...overrideConfig, serviceIdx })
        return auth.axiosIns.get(`/v1/tags/qtype/project/${projectIdx}`)
    },
    /** CSP 취약점 조치 */
    /** Download */
    simpleExcel ({ usageAccountId, month }, serviceIdx) {
        const { auth } = useAuth({ ...overrideConfig, serviceIdx })
        return auth.axiosIns.get(`/v1/hyper-common/download/summary/simple/${usageAccountId}/${month}`, { responseType: 'blob' })
    },
    detailCSV ({ usageAccountId, month }, serviceIdx) {
        const { auth } = useAuth({ ...overrideConfig, serviceIdx })
        return auth.axiosIns.get(`/v1/hyper-common/download/summary/detail/${usageAccountId}/${month}`)
    },
    /** Summary & Invoice */
    getAvailableInvoice ({ usageAccountId, month }, serviceIdx) {
        const { auth } = useAuth({ ...overrideConfig, serviceIdx })
        return auth.axiosIns.get(`/v1/hyper-common/invoice/${usageAccountId}/months/${month}`)
    },
    invoicePDF ({ usageAccountId, month, locale }, serviceIdx) {
        const { auth } = useAuth({ ...overrideConfig, serviceIdx })
        return auth.axiosIns.get(`/v1/hyper-common/download/invoice/${usageAccountId}/${month}/${locale}/invoice.pdf`, { responseType: 'blob' })
    },
    /** Cost Pivot Filter */
    fetchCostPivotFilter ({ costPivotFilterIdx }, serviceIdx) {
        const { auth } = useAuth({ ...overrideConfig, serviceIdx })
        return auth.axiosIns.get(`/v1/hyper-common/cost-pivot/filter/${costPivotFilterIdx}`)
    },
    fetchCostPivotFilterNames ({ userIdx }, serviceIdx) {
        const { auth } = useAuth({ ...overrideConfig, serviceIdx })
        return auth.axiosIns.get(`/v1/hyper-common/cost-pivot/filter/user/${userIdx}/names`)
    },
    createCostPivotFilter ({ userIdx, name, content }, serviceIdx) {
        const { auth } = useAuth({ ...overrideConfig, serviceIdx })
        return auth.axiosIns.post('/v1/hyper-common/cost-pivot/filter', { userIdx, name, content })
    },
    deleteCostPivotFilter ({ costPivotFilterIdx }, serviceIdx) {
        const { auth } = useAuth({ ...overrideConfig, serviceIdx })
        return auth.axiosIns.delete(`/v1/hyper-common/cost-pivot/filter/${costPivotFilterIdx}`)
    }
}

export {
    service,
    overrideConfig,
    useAuth
}
